import styled from 'styled-components';

export const ResizeHandleBar = styled.div`
    display: inline-block;
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    width: 8px;
    cursor: col-resize;
    user-select: none;
    touch-action: none;
    z-index: 10;

    /* Always-visible separator line */
    &::after {
        content: '';
        position: absolute;
        right: 3px;
        top: 15%;
        height: 70%;
        width: 2px;
        background-color: rgba(0, 0, 0, 0.18);
        border-radius: 1px;
        transition: background-color 0.15s ease;
    }

    &:hover::after,
    &.isResizing::after {
        background-color: ${({ theme }) => theme.colors.accent};
    }

    &:focus {
        outline: none;
    }

    &:focus::after {
        background-color: ${({ theme }) => theme.colors.accent};
        box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.accent}40;
    }
`;

export const TableIcon = styled.img`
    transform: rotate(${({ isExpanded }) => (isExpanded ? '180deg' : '0deg')});
    transition-property: transform;
    transition-duration: 0.9s;
    transition-timing-function: cubic-bezier(0.77, 0.35, 0.46, 1.04);
`;

export const TableRowExpantionButton = styled.button`
    outline: none;
    border: none;
    background-color: transparent;
    align-self: center;
`;

/* ---- Stacked (collapsed) layout for narrow containers ------------------- *
 * Below COLLAPSE_BREAKPOINT each row renders as a block of label/value pairs
 * instead of a horizontal strip of cells, so the table never scrolls
 * sideways on a phone (PM-18150 edge case).
 * -------------------------------------------------------------------------- */

export const StackedTableRow = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0.75rem;
    line-height: 1.6rem;
    border-bottom: 1px solid rgb(241, 241, 241);
    &:hover {
        background-color: rgba(0, 0, 0, 0.04) !important;
    }
`;

export const StackedTableCell = styled.div`
    display: flex;
    align-items: baseline;
    width: 100%;
    min-width: 0;
    padding: 2px 0;
`;

export const StackedCellLabel = styled.span`
    flex: 0 0 40%;
    max-width: 40%;
    padding-right: 8px;
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
    color: #6b7280;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const StackedCellValue = styled.span`
    flex: 1 1 auto;
    min-width: 0;
`;
